import React, { useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import Peduli from "assets/img/culture/peduli_insani-removebg-preview.png";
import Panca from "assets/img/culture/PANCADAYA-HD.png";
import peeduli from "assets/img/1.png";
import insani from "assets/img/2.png";
import ExamplesNavbar from "../../components/Navbars/ExamplesNavbar";
import CulturePageHeader from "../../components/Headers/CulturePageHeader";
import DefaultFooter from "../../components/Footers/DefaultFooter";

function CulturePage() {
    const openImageInNewTab = (imageSrc) => {
        window.open(imageSrc, "_blank");
    };

    // useEffect to handle adding/removing classes on mount/unmount
    useEffect(() => {
        document.body.classList.add("profile-page");
        document.body.classList.add("sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;

        return function cleanup() {
            document.body.classList.remove("profile-page");
            document.body.classList.remove("sidebar-collapse");
        };
    }, []);

    return (
        <>
            <ExamplesNavbar />
            <div className="wrapper">
                <CulturePageHeader />
                <div className="section">
                    <Container className="sec__one culture">
                        <Container className="culture-container">
                            <Row>
                                <Col className="text-center">
                                    <h2
                                        className="text-black mt-50"
                                        data-aos="fade-right"
                                        data-aos-delay="100"
                                    >
                                        <b>BUDAYA</b>
                                    </h2>
                                </Col>
                            </Row>

                            <Row
                                className="justify-content-center"
                                data-aos="fade-up"
                                data-aos-delay="100"
                            >
                                <Col xs="12" md="7" className="text-center">
                                    <img
                                        src={Peduli}
                                        alt="peduli insani"
                                        onClick={() => openImageInNewTab(Peduli)}
                                        style={{ cursor: "pointer", maxWidth: "100%" }}
                                    />
                                </Col>
                            </Row>

                            <Row className="box-pancadaya box-top justify-content-center">
                                <Col xs="12" md="6" data-aos="fade-left">
                                    <img
                                        src={peeduli}
                                        onClick={() => openImageInNewTab(peeduli)}
                                        alt="peduli"
                                        style={{
                                            cursor: "pointer",
                                            maxWidth: "100%",
                                            marginTop: "30px",
                                        }}
                                    />
                                </Col>
                            </Row>

                            <Row className="box-pancadaya box-top justify-content-center">
                                <Col xs="12" md="6" data-aos="fade-right">
                                    <img
                                        src={insani}
                                        onClick={() => openImageInNewTab(insani)}
                                        alt="insani"
                                        style={{
                                            cursor: "pointer",
                                            maxWidth: "100%",
                                            marginBottom: "70px",
                                        }}
                                    />
                                </Col>
                            </Row>

                            <Row>
                                <Col
                                    className="text-center"
                                    data-aos="fade-right"
                                    data-aos-delay="100"
                                >
                                    <h2>
                                        <b>KARAKTER</b>
                                    </h2>
                                </Col>
                            </Row>

                            <Row
                                className="justify-content-center"
                                data-aos="fade-up"
                                data-aos-delay="700"
                            >
                                <Col xs="12" md="7" className="text-center">
                                    <img
                                        src={Panca}
                                        alt="Panca Daya"
                                        onClick={() => openImageInNewTab(Panca)}
                                        style={{ cursor: "pointer", maxWidth: "100%" }}
                                    />
                                </Col>
                            </Row>
                        </Container>
                    </Container>
                </div>
                <DefaultFooter />
            </div>
        </>
    );
}

export default CulturePage;
